import React, { useEffect } from 'react';
import { CheckCircle, AlertTriangle, Info, X } from 'lucide-react';

const Toast = ({ message, type, onDismiss }) => {
    const toastStyles = {
        success: { bg: 'bg-green-100', text: 'text-green-800', icon: <CheckCircle size={18} /> },
        error: { bg: 'bg-red-100', text: 'text-red-800', icon: <AlertTriangle size={18} /> },
        info: { bg: 'bg-blue-100', text: 'text-blue-800', icon: <Info size={18} /> },
    };
    const currentStyle = toastStyles[type] || toastStyles.error;

    useEffect(() => {
        const timer = setTimeout(onDismiss, 5000);
        return () => clearTimeout(timer);
    }, [onDismiss]);

    return (
        <div className="fixed top-20 right-5 z-50 animate-fade-in-down">
            <div className={`flex items-center gap-3 p-4 rounded-lg shadow-lg ${currentStyle.bg} ${currentStyle.text}`}>
                {currentStyle.icon}
                <span className="text-sm font-medium">{message}</span>
                <button onClick={onDismiss} className="ml-4 text-gray-500 hover:text-gray-800">
                    <X size={16} />
                </button>
            </div>
        </div>
    );
};

export default Toast;
